const state = {
  plan_details: {},
  group_id: 0,
  orderProductList: [],
};

const mutations = {
  getPlanDetails(state, data) {
    state.plan_details = data;
  },
  getGroupId(state, data) {
    state.group_id = data;
  },
  clearGroupId(state) {
    state.group_id = 0;
  },
  updateStockPointList(state, data) {
    state.plan_details.stockpoint_list = data;
  },
  setOrderProducts(state, data) {
    state.orderProductList = data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
